module.exports = __webpack_public_path__ + "static/case_janet-58153c00d69376526a27c86196a8bf43.jpg";